export type CustomField = {
	id: CustomFieldType;
	name: string;
	selected: boolean;
	removable: boolean;
};

export type SystemField<Type extends string> = {
	id: Type;
	name: string;
	selected: boolean;
	removable: boolean;
};

export type Field<Type extends string> = CustomField | SystemField<Type>;

export enum SystemFieldType {
	name = 'name',
	description = 'description',
	qr = 'codes',
	barcode = 'barcodes',
	rfid = 'rfidcodes',
	created = 'created',
	modified = 'modified',
	items = 'items',
}

export type CustomFieldType = `fields.${string}`;

export type FieldType = SystemFieldType | CustomFieldType;
